// extracted by mini-css-extract-plugin
module.exports = {"ball-clip-rotate":"styles_ball-clip-rotate__2cvNX","rotate":"styles_rotate__ZYRt-"};